/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { createStore } from 'redux';

const initialState = {
    user: {
        id: 0,
        firstName: '',
        lastName: '',
        profileImage: null,
        roleid: null
    },
    sidebar: false,
    footer: true,
    toggleSidebar: false,
    refreshInterval: '',
    logoutModal: false,
    toggleSignInModal: { open: false, mode: 'Sign-In', fromBannerBtn: false , moveToHomeonCancel:false, itemview: false},
    toggleForgotPasswordModal: { open: false, mode: 'Forgot-Password' },
    sidebarMenuList: { menuList: [], withSpan: false },
    header: true,
    covidBanner: true,
    showEstateDetail: { show: false, extraData: null },
    signinFormLoading: false,
    searchBoxShow: true,
    payPalPage: { amount: 0, redirectTo: null },
    customSidebar: { icon: false, open: false },
    doorImageDefaultHeight: 0,
    setExtraZIndex: false,
    checkExistsModal: { show: false, extraData: null },
    previousPath: { component: null },
    refreshModal: false,
    nlpSearch: false,
    updateLocation: null,
    networkSlow: false,
    showOffilePopUp: false,
    showErrorModal: { show: false, message: null },
    toggleNotificationModal: {show: false, navigateData: null},
    showErrorModal: { show: false, message: null, link: null },
    toggleRegisterModal: false,
    toggleSuspendModal: false,
    googleAdsValue: {},
    premierBannerImg: '',
    membershipModal: { show: false },
    category: [],
    exploreModal:false,
    homebanner: {},
    privacyPolicy: {},
    resize: {},
    scroll: {},
    currentPath: '',
    statemaintenance : {},
    sseItemIds: [],
    featureItemList:[]
};

/* sets the current state else returns initial state */
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USER':
            return Object.assign({}, state, { user: action.payload });
        case 'SET_REFRESH':
            return Object.assign({}, state, { refreshInterval: action.payload });
        case 'SET_SIDEBAR':
            return Object.assign({}, state, { sidebar: action.payload });
        case 'FOOTER':
            return Object.assign({}, state, { footer: action.payload });
        case 'TOGGLE_SIDEBAR':
            return Object.assign({}, state, { toggleSidebar: action.payload });
        case 'TOGGLE_LOGOUT_MODAL':
            return Object.assign({}, state, { logoutModal: action.payload });
        case 'TOGGLE_SESSION_MODAL':
            return Object.assign({}, state, { sessionModal: action.payload });
        case 'TOGGLE_REGISTER_MODAL':
            return Object.assign({}, state, { toggleRegisterModal: action.payload });
        case 'TOGGLE_SUSPEND_MODAL':
            return Object.assign({}, state, { toggleSuspendModal: action.payload });
        case 'TOGGLE_SIGNIN_MODAL': { const payload = {  ...action.payload,  itemview: action.payload.itemview === true   };
            return {  ...state,   toggleSignInModal: { ...state.toggleSignInModal,  ...payload }};  }  
        case 'SET_APP_TOKEN':
            return Object.assign({}, state, { appToken: action.payload });
        case 'SIDEBAR_MENU_LIST':
            return Object.assign({}, state, { sidebarMenuList: action.payload });
        case 'SET_HEADER':
            return Object.assign({}, state, { header: action.payload });
        case 'SET_COVID_BANNER':
            return Object.assign({}, state, { covidBanner: action.payload });
        case 'SHOW_ESTATE_DETAIL':
            return Object.assign({}, state, { showEstateDetail: action.payload });
        case 'SET_SIGNIN_FORM_LOADING':
            return Object.assign({}, state, { signinFormLoading: action.payload });
        case 'TOGGLE_SEARCH_BOX':
            return Object.assign({}, state, { searchBoxShow: action.payload });
        case 'PAYPAL_PAYMENT_PAGE':
            return Object.assign({}, state, { payPalPage: action.payload });
        case 'TOGGLE_FORGOT_PASSWORD':
            return Object.assign({}, state, { toggleForgotPasswordModal: action.payload });
        case 'SET_CUSTOM_SIDEBAR':
            return Object.assign({}, state, { customSidebar: action.payload });
        case 'SET_DOOR_HEIGHT':
            return Object.assign({}, state, { doorImageDefaultHeight: action.payload });
        case 'SET_EXTRA_Z_INDEX':
            return Object.assign({}, state, { setExtraZIndex: action.payload });
        case 'TOGGLE_CHECK_EXISTS_MODAL':
            return Object.assign({}, state, { checkExistsModal: action.payload });
        case 'SET_PREVIOUS_PATH':
            return Object.assign({}, state, { previousPath: action.payload });
        case 'TOGGLE_REFRESH_MODAL':
            return Object.assign({}, state, { refreshModal: action.payload });
        case 'UPDATE_NLP_SEARCH':
            return Object.assign({}, state, { nlpSearch: action.payload });
        case 'UPDATE_FAVORITE_LOCATION':
            return Object.assign({}, state, { updateLocation: action.payload });
        case 'NETWORK_SLOW':
            return Object.assign({}, state, { networkSlow: action.payload });
        case 'OFFLINE_POPUP':
            return Object.assign({}, state, { showOffilePopUp: action.payload });
        case 'ERROR_MODAL':
            return Object.assign({}, state, { showErrorModal: action.payload });
        case 'TOGGLE_NOTIFICATION_MODAL':
            return Object.assign({}, state, { toggleNotificationModal: action.payload });
        case 'SET_GOOGLE_ADS_USER':
            return Object.assign({}, state, { googleAdsValue: action.payload });
        case 'PREMIER_BANNER_IMAGE':
            return Object.assign({}, state, { premierBannerImg: action.payload });
        case 'MEMBERSHIP_MODAL':
            return Object.assign({}, state, { membershipModal: action.payload });
        case 'CATEGORY':
            return Object.assign({}, state, { category: action.payload });
        case 'HOMEBANNER':
                return Object.assign({}, state, { homebanner: action.payload });   
        case 'PRIVACY_POLICY':
                return Object.assign({}, state, { privacyPolicy: action.payload });    
        case 'EXPLORE_MODAL':
            return Object.assign({}, state, { exploreModal: action.payload });
        case 'ROUTE_CHANGE':
                return Object.assign({}, state, { currentPath: action.payload });
        case 'PUSH_TO_STATE':
            return Object.assign({}, state, { statemaintenance: action.payload });
        case 'BIDS':
            return Object.assign({}, state, { sseItemIds: action.payload });
        case 'MULTI_LIST':
            return Object.assign({}, state, { featureItemList: action.payload });
        default:
            return state;
    }
};

export default createStore(reducer);